module.exports = __webpack_public_path__ + "assets/events_black.bf59f6e1.svg";